import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-historial-reprog',
  templateUrl: './historial-reprog.component.html',
  styleUrls: ['./historial-reprog.component.scss']
})
export class HistorialReprogComponent implements OnInit, OnDestroy, AfterViewInit {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data,
    private _cartera: CarteraService
  ) 
  { 
    this.dtTrigger.next();

    this.dtOptions = {
      order: [0, 'desc'],
      scrollCollapse: true,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title: 'Fecha - Hora',
          data: 'fecha_registro'
        },
        {
          title: 'N° Cobro',
          data: 'n_cobro',
        },
        {
          title: 'N° Factura',
          data: 'n_factura'
        },{
          title: 'Tipo Reprogramación',
          data: 'reprogramacion'
        },
        {
          title: 'Fecha Reprogramación',
          data: 'FechaReprogramacion'
        },
        {
          title: 'Cobrador',
          data: 'cobrador'
        },
        {
          title: 'Creador',
          data: 'usuario_creador'
        }
      ],
      responsive: true
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerHistorialReprogramacion(this._data.cobro).subscribe((data: Array<any>) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // ----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
